/* eslint-disable security/detect-object-injection */
/* eslint-disable max-len */
/* eslint-disable react/jsx-no-undef */
import React, { useContext, useEffect, useRef, useState } from 'react'
import moment from 'moment'
import { motion } from 'framer-motion'
import { Link, useLocation, useNavigate, useParams, useSearchParams } from "react-router-dom"
import TopHeader from '../../../../../components/TopHeader'
import CustomOverLay from '../../../../../components/CustomOverLay'
import { useGetMonitorAssociatedToPatientListQuery, useListWellnessNotesQuery, useExportPatientNotesMutation } from '../../../../../slices/patientSlice'
import GlobalContext from '../../../../../components/Context/GloablContext'
import TextArea from '../../../../../components/TextArea'
import SearchEmptyScreen from '../../../../../components/SearchEmptyScreen'
import TextAreaWellness from '../../../../../components/TextAreaWellness'
import Loader from '../../../../../components/Loader'
import { convertEpochToDateFormat } from '../../../../../CommonMethods/convertEpochToDateFormat'
import { useDispatch, useSelector } from 'react-redux'
import {convertDatesToEpochUTC} from '../../../../../CommonMethods/ConvertFilterDatetoEpochUtcFormat'
import Emptyscreen from '../../../../../components/EmptyScreen'
import ConfirmationPrompt from '../../../../../components/ConfirmationPrompt'
import AnimatedModel from '../../../../../components/Animation/AnimatedModel'
import { useAddNotesMutation } from '../../../../../slices/patientSlice'
import FilterDeviceBtn from '../WellnessFilter'
import { handleAddFilterValues, handleIsViewScreen, resetFilterState } from '../../../../../redux/systemConfigSlice'
import { dataService } from '../../../../../services/data.services'
import HelpGuideModal from '../../../../../components/HelpGuideModal'
import {useGetHelpGuideProviderQuery} from '../../../../../slices/patientSlice'
import { organizationusersList } from '../../../../../slices/apiSlice'


const ContactHistory = ({ }) => {
    const location = useLocation()
    const navigate = useNavigate()
    const { id, patientId } = useParams()
    const dispatch = useDispatch()
    const dateformat = useSelector(state => state?.systemConfigData?.globalVariables?.date_format)
    const filtervals = useSelector(state => state.systemConfigData.filterState)
    const user_type = sessionStorage.getItem('user_type')
    const user_id = sessionStorage.getItem('user_id');
    const [helpGuideModel, setHelpGuideModel] = useState(false);
    const [triggerApiCall, setTriggerApiCall] = useState(false);
    const [queryParamsorg, setQueryParamsorg] = useState('')
    const userType = sessionStorage.getItem('user_type')
      
    const { data: helpguidedata, status: helpguidestatus } = useGetHelpGuideProviderQuery(queryParamsorg, {
        skip: !triggerApiCall,  // Skip the query until the trigger is set to true
    });
    // const monitor_permission = sessionStorage.getItem('monitor_permission')
    const { isSideBar, setToastmessage, setToastErrorMessage, currentTime, startTimer, stopTimer, resetTimer, wellnessNotes, setWellnessNotes, patientIdfromGlobal, setPatientIdFromGlobal, seconds, minutes, hours, isTimerStarted, sumbitButtonClicked, emptyWellness, setEmptyWellness } = useContext(GlobalContext)

    const [addNotes] = useAddNotesMutation()
    const [exportNotes] = useExportPatientNotesMutation()
   
    const [exportLoading, setExportLoading] = useState(false)
    const [searchParams, setSearchParams] = useSearchParams({})

    let queryObject = {
        id: patientId
    };
    if (searchParams) {
        const params = Object.fromEntries(searchParams);
        if (params.monitor_list) {
            // Split monitor_list string into an array using comma as delimiter
            params.monitor_list = params.monitor_list.split(',');
        }
        queryObject.body = {
            ...params
        };
    }
    const { data, isFetching, status, refetch } = useListWellnessNotesQuery(
        queryObject,
        { refetchOnMountOrArgChange: true }
    );
    
    const { data: monitorsList, isFetching: monitorsFetching, isLoading, status: monitorslistStatus } = useGetMonitorAssociatedToPatientListQuery(patientId, { refetchOnMountOrArgChange: true })
    const matchingObject = monitorsList && monitorsList.data.find(obj => obj.monitorUserData.user_id === user_id);
    const [addNoteModal, setAddWellnessModal] = useState(false)
    const [saveThreedotLoader, setSaveThreeedotLoader] = useState(false)
    const [dateError, setdateError] = useState(false)
    const [isFilterOpen, setIsFilterOpen] = useState(false);
    const initialState = {
        "filter_start_date": '',
        "filter_end_date": '',
        'monitor_list': [],
    }
    const [filterValues, setFilterValues] = useState(initialState);
    const [submit, setSubmit] = useState(false)

    const [collapsedNotes, setCollapsedNotes] = useState([]);

    useEffect(() => {
        if (status === "fulfilled" && data?.patientData) {
            // Initialize collapsedNotes based on the condition
            const initialCollapsedState = data.patientData.map((_, index) => index !== 0);
            setCollapsedNotes(initialCollapsedState);
        }
    }, [status, data]);

    const handleCollapseToggle = (index) => {
        setCollapsedNotes(prev => {
            const newCollapsedNotes = [...prev];
            newCollapsedNotes[index] = !newCollapsedNotes[index];
            return newCollapsedNotes;
        });
    };

    useEffect(() => {
        const adjustTextareaHeight = () => {
            const textareas = document.querySelectorAll('.auto-height-textarea');

            textareas.forEach((textarea) => {
                textarea.style.height = 'auto';
                textarea.style.height = `${textarea.scrollHeight}px`;
            });
        };
        // Call the adjustTextareaHeight function after the initial render
        adjustTextareaHeight();

        // Attach the adjustTextareaHeight function to the resize event to handle dynamic content changes
        window.addEventListener('resize', adjustTextareaHeight);
        // Clean up the event listener to prevent memory leaks
        return () => {
            window.removeEventListener('resize', adjustTextareaHeight);
        };
    }, [data && data.patientData, collapsedNotes]);

    useEffect(() => {
        if (userType === 'monitor-user') {
            setQueryParamsorg('type=monitor-contact-history');
        } else {
            setQueryParamsorg('type=provider-contact-history');
        }
    }, [userType]);
      
    useEffect(() => {
        if (queryParamsorg) {
            setTriggerApiCall(true);  // Allow the query to run
        }
    }, [queryParamsorg]);


    const handleChangeInput = (id, value) => {
        setEmptyWellness(false)
        setSubmit(false);
        // Check if the entered value starts with a space
        if (value.charAt(0) === ' ') {
            // If yes, trim the leading space and update the state
            setWellnessNotes(value.trim());
        } else {
            // If not, update the state as usual
            setWellnessNotes(value);
        }
    }

    async function handleExport(type, patientId) {
        let noteType = type;
        setExportLoading(true);
        const params = Object.fromEntries(searchParams);
        // Define default payload with query parameters
        let payload = {
            patientId,
            dateformat,
            noteType,
        };
        // Check if either start_date or end_date is not empty
        if (params.start_date || params.end_date) {
            payload.filter = 'true';
            // Assuming you have these predefined
            payload.start_date = params.start_date;
            payload.end_date = params.end_date;
        }

        // Check if monitor_list is not empty
        if (params.monitor_list && params.monitor_list !== '') {
            // Split monitor_list into an array of strings
            const monitorListArray = params.monitor_list.split(',').map(item => item.trim());

            // Add monitor_list to payload body as an array of strings
            payload.user_id = monitorListArray;
        }
        const exportRes = await exportNotes(payload);
        setExportLoading(false);
        window.open(exportRes?.data?.presigned_url);

        if (exportRes?.error) {
            setToastErrorMessage("Something went wrong");
        } else {
            setToastmessage(exportRes?.data?.message);
        }
    }

    useEffect(() => {
        setPatientIdFromGlobal(patientId)
    }, [])
    
    const handleSaveClick = () => {
        if (wellnessNotes === '') {
            setSubmit(true);
            setToastErrorMessage("Please fill in all the mandatory fields");
            return
        } else {
            setAddWellnessModal(true)
        }
    }

    const handleAppendNotes = async () => {
        setSaveThreeedotLoader(true)
        const body = {
            "patient_id": patientId,
            "note_type": "wellness-note",
            "description": wellnessNotes
        }
        const response = await addNotes(body)
        if (response) {
            setToastmessage(response.data.message)
            setSaveThreeedotLoader(false)
            setAddWellnessModal(false)
            setWellnessNotes('')
        } else {
            setSaveThreeedotLoader(false)
            setAddWellnessModal(false)
        }
    }

    const user_type_labels = {
        "admin-user": "Admin",
        "super-admin": "Super Admin",
        "corporate-user": "Corporate",
        "organization-user":"Organization User",
        "provider":"Provider",
        "observer":"Observer",
        "monitor-user": "Monitor",
    }

    const handleApplyFilter = (type) => {
        let params = { ...Object.fromEntries(searchParams) };
        const start_date = moment(filterValues.filter_start_date).format('YYYY-MM-DD');
        const end_date = moment(filterValues.filter_end_date).format('YYYY-MM-DD');

        const filterValuesToDispatch = {};

        if (filterValues.filter_start_date) {
            filterValuesToDispatch["filter_start_date"] = filterValues.filter_start_date;
        }

        if (filterValues.filter_end_date) {
            filterValuesToDispatch["filter_end_date"] = filterValues.filter_end_date;
        }

        if (Array.isArray(filterValues.monitor_list) && filterValues.monitor_list.length > 0) {
            filterValuesToDispatch["monitor_list"] = filterValues.monitor_list.join(',');
        } else if (filterValues.monitor_list !== "") {
            filterValuesToDispatch["monitor_list"] = filterValues.monitor_list;
        }

        if (type) {
            const startDateEpoch = filterValues.filter_start_date !== "" ? convertDatesToEpochUTC(start_date, 'UTC', true) : undefined
            const endDateEpoch = filterValues.filter_end_date !== "" ? convertDatesToEpochUTC(end_date, 'UTC', false) : undefined

            const updatedParams = {
                filter: "true",
                ...(startDateEpoch && { start_date: startDateEpoch }),
                ...(endDateEpoch && { end_date: endDateEpoch }),
                ...(filterValues.monitor_list.length > 0 && { monitor_list: filterValues.monitor_list.join(',') }),
            };
            setSearchParams(updatedParams);

        }else {
            // Preserve the search parameter and remove only the filter-related parameters
            delete params['monitor_list'];
            delete params['start_date'];
            delete params['end_date'];
            setSearchParams(params);
        }
        if (filterValuesToDispatch.monitor_list.length === 0) {
            delete filterValuesToDispatch.monitor_list
        }
        // Dispatch filter values regardless of the 'type'
        dispatch(handleAddFilterValues(filterValuesToDispatch));
    };

    useEffect(() => {
        if (searchParams.get("start_date") === null && searchParams.get("end_date") === null) {
            dispatch(resetFilterState())
        }
    }, [searchParams])

    function handleCheckBox(key, option) {
        setIsAnyFieldFilled !== undefined && setIsAnyFieldFilled(true)
        setFilterValues((prev) => {
            const updatedFilterValues = { ...prev };
            // If the key already exists, toggle the option in the array
            updatedFilterValues[key] = updatedFilterValues[key] ? (
                updatedFilterValues[key].includes(option)
                    ? updatedFilterValues[key].filter(item => item !== option)
                    : [...updatedFilterValues[key], option]
            ) : [option];
            return updatedFilterValues;
        });
    }

    const handleClearFilter = () => {
        let params = Object.fromEntries(searchParams);
        delete params.monitor_list
        delete params.status
        delete params.end_date
        delete params.start_date
        setSearchParams({ ...params })
    }


    const handleOpenFilter = () => {
        setdateError(false)
        // Check for monitor_list, status, filter_start_date, and filter_end_date
        if ((searchParams.get("monitor_list") !== null || searchParams.get("start_date") !== null || searchParams.get("end_date") !== null) && !isFilterOpen) {
            setFilterValues((prevFilterValues) => ({
                ...prevFilterValues,
                "filter_start_date": filtervals.filter_start_date,
                "filter_end_date": filtervals.filter_end_date,
                monitor_list: searchParams.get("monitor_list")?.split(',') || [],
            }));

        } else if (searchParams.get("monitor_list") === null && searchParams.get("start_date") === null && searchParams.get("end_date") === null) {
            setFilterValues({
                "filter_start_date": '',
                "filter_end_date": '',
                'monitor_list': [],
            });
        }
        setIsFilterOpen(!isFilterOpen);
    };

    const ApplyFilter = (data === undefined) ? false : true

    const  startTimerCaputreApi= async () => {
        try {
            const response = await dataService.PostAPI('',`users/acivity-logs?action=start_contact&patient_id=${patientId}`)
        } catch (error) {
            console.error('error', error);
        }
    };

    return (
        <>
            <div className='bg-[#F9F3F5] pt-[95px] px-[30px] h-full w-full overflow-x-hidden'>
                <TopHeader title={"Manage Patients"} />
                {/* isFetching&&status!=="fulfilled" */}
                {isFetching && status !== "fulfilled" ? <CustomOverLay Active text="Loading Patient Details..." classKey={`absolute top-0 left-0 z-50 overflow-hidden bg-gray-400 opacity-75 flex flex-col items-center justify-center ${isSideBar ? 'opened-sidebar-config' : 'system_config_overlay'}`} /> : status === "rejected" ? <SearchEmptyScreen text={"No data found"} /> : <>
                    <div className='bg-white rounded-lg py-[12px] px-[30px] h-customh3'>
                        <motion.div
                            className="mt-1"
                            animate={{ x: 0 }}
                            initial={{ x: -10 }}
                            transition={{ duration: 0.5 }}
                        >
                            <div className='bg-white'>
                                <div className='flex items-center mb-2'>
                                    <Link to="/manage-patients" state={Array.isArray(location.state) ? '' : location.state}>
                                        <h1 className="text-sm font-normal text-[#52555D]">List of Patients</h1>
                                    </Link>
                                    <span className='mx-2'><img src="/images/breadcrumb-icon.svg" alt="icon" /></span>
                                    <Link to={`/manage-patients/view-patient/${id}`}>
                                        <h1 className="text-sm font-normal text-[#52555D]">View Patient</h1>
                                    </Link>
                                    <span className='mx-2'><img src="/images/breadcrumb-icon.svg" alt="icon" /></span>
                                    
                                    <h1 className="text-sm font-normal text-[#008586]">Patient Contact Management</h1>
                                    <span   onClick={() => setHelpGuideModel(true)} className=' ml-auto cursor-pointer'>
                                        <img src="/images/helpguideicon.png" alt="icon" loading="lazy" decoding="async" />
                                    </span> 
          
                                 
                                </div>
                                <div className="flex items-center w-full  pb-2">
                                    <Link to={`/manage-patients/view-patient/${id}`} state={Array.isArray(location.state) ? '' : location.state} className='flex items-center min-w-max z-[99]'>
                                        <span><img src="/images/back_button_Green.svg" alt="icon" /></span>
                                        <span className='text-sm font-normal text-[#008586] ml-3'>Go back to View Patient</span>
                                    </Link>
                                    <div className='flex w-full justify-end'>
                                        {
                                            userType === 'monitor-user' &&
                                            <button type="button"
                                                id={'activity-log'}
                                                onClick={() => { navigate(`/manage-patients/view-patient/${id}/vital-history/device/${patientId}`, { state: { ...location.state, fromScreen: 'view',patientId ,id, cameFrom: 'contact_history',} }) }}
                                    
                                                className={`h-[41px] px-4 flex items-center text-[18px] leading-[24px] font-medium text-[#fff] 
                                rounded-[16px] bg-[#972E4C]  min-w-max focus:bg-[#863B50] disabled:bg-[#777C88] xl:mr-4 ml-[14px] `}
                                            >
                                                Device Reading History
                                            </button>
                                        }
                                        
                                        <button type="button"
                                            id={'activity-log'}
                                            onClick={() =>{dispatch(organizationusersList.util.resetApiState());navigate(`/manage-patients/view-patient/${id}`)}}
                                            className={`h-[41px] px-4 flex items-center text-[18px] leading-[24px] font-medium text-[#fff] 
                                rounded-[16px] bg-[#972E4C]  min-w-max focus:bg-[#863B50] disabled:bg-[#777C88] ml-2 `}
                                        >
                                            View Patient Details
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <p className='text-xl font-semibold text-center text-[#000000] pb-[24px]  static top-0 left-0 z-20 w-full '>
                                Patient Contact Management
                            </p>
                            <div className='h-[calc(100vh-285px)] scrollbar_gray pr-4 overflow-x-hidden'>
                            
                                { (matchingObject?.monitor_permission === 'monitor' || user_type === 'provider' )&&
                                    <>
                                        {user_type !== 'provider' && <div className='w-full mx-4'>
                                            <p> </p>
                                            <div className='flex mt-2.5 w-full'>
                                                <button type="button"
                                                    id={'start_time'}
                                                    onClick={() => {startTimerCaputreApi(),startTimer()}}
                                                    disabled={isTimerStarted}
                                                    className={`h-[41px] px-4 flex items-center text-[18px] leading-[24px] font-medium text-[#fff] 
                                            rounded-[16px] bg-[#972E4C]  min-w-max focus:bg-[#863B50] disabled:bg-[#777C88] xl:mr-4 ml-2 `}
                                                >
                                                    Start Timer
                                                </button>
                                                <button type="button"
                                                    id={'end_time'}
                                                    onClick={() => { stopTimer() }}
                                                    disabled={!isTimerStarted || sumbitButtonClicked}
                                                    className={`h-[41px] px-4 flex items-center text-[18px] leading-[24px] font-medium text-[#fff] 
                                                    rounded-[16px] bg-[#972E4C] justify-center xl:w-[330px] w-[425px] focus:bg-[#863B50] disabled:bg-[#777C88] xl:mr-4 ml-2 `}
                                                >
                                                    {sumbitButtonClicked ? <Loader /> : `End Contact & Save`}
                                                </button>
                                                <div className='flex justify-end items-end w-full mr-[32px]'>
                                                    <h1 className='text-xl font-normal text-[#000000] '>Contact Session Timer: <span className='text-[#008586]'>{hours.toString().padStart(2, '0')}</span>:<span className='text-[#008586]'>{minutes.toString().padStart(2, '0')}</span>:<span className='text-[#008586]'>{seconds.toString().padStart(2, '0')}</span></h1>
                                                </div>
                                            </div>
                                        </div>}
                                        <div>
                                            <div className='pl-4 2xl:pl-[20px] mt-[16px] rounded-[8px] pr-4  pt-2 overflow-auto overflow-x-hidden scrollbar_grayw6 '>
                                                <TextAreaWellness
                                                    PatientNotes={true}
                                                    dataTestid={'wellness-Notes'}
                                                    htmlFor={'wellness-Notes'}
                                                    id={'wellness-Notes'}
                                                    value={wellnessNotes}
                                                    placeholder={'Type note here...'}
                                                    emptyField={(submit && wellnessNotes === "") || (emptyWellness && wellnessNotes === '')}
                                                    handleOnChangeInput={handleChangeInput}
                                                    handleOnCLickActivate={''}
                                                // add={isAddnote}
                                                // loadingActivation={false}
                                                />
                                            </div>
                                            {user_type === 'provider' &&
                                                <button type="button"
                                                    id={'save'}
                                                    onClick={() => { handleSaveClick() }}
                                                    // disabled={!isTimerStarted}
                                                    className={`h-[41px] px-4 flex items-center text-[18px] leading-[24px] font-medium text-[#fff] 
                                                    rounded-[16px] bg-[#972E4C]  min-w-max focus:bg-[#863B50] disabled:bg-[#777C88] xl:mr-4 ml-3 mt-3 `}
                                                >
                                                    {`Save`}
                                                </button>
                                            }
                                        </div>
                                    </>}
                                <div className='mt-4 flex z-20 sticky top-0 bg-white pl-[17px] pr-[10px] justify-between'>
                                    <p className='text-xl font-semibold text-[#000000]'>Wellness Contact History</p>
                                    <div className='flex justify-end'>
                                        {(ApplyFilter !== undefined && ApplyFilter) &&
                                            <FilterDeviceBtn
                                                dateError={dateError}
                                                setdateError={setdateError}
                                                isFilterOpen={isFilterOpen}
                                                setIsFilterOpen={setIsFilterOpen}
                                                handleApplyFilter={handleApplyFilter}
                                                filterValues={filterValues}
                                                setFilterValues={setFilterValues}
                                                initialState={initialState}
                                                // setIsAnyFieldFilled={setIsAnyFieldFilled}
                                                handleClearFilter={handleClearFilter}
                                                handleCheckBox={handleCheckBox}
                                                // isPatient={isPatient}
                                                handleOpenFilter={handleOpenFilter}
                                                monitorsList={monitorsList && monitorsList.data}
                                            />
                                        }
                                        {(data.patientData.length !== 0) &&
                                            <button id="icon-export" disabled={exportLoading} onClick={() => handleExport("wellness-note", patientId)} className="border border-[#972E4C] rounded-[15px] px-[15px] py-[13px] disabled:cursor-not-allowed ml-4">
                                                {exportLoading ?
                                                    <div className='flex justify-center items-center'>
                                                        <div className="loader ease-linear rounded-full border-t-4 border-[#972E4C] h-5 w-5 spin-animation"></div>
                                                    </div>
                                                    : <img src="/images/download-red.svg" alt="download-icon" />}
                                            </button>
                                        }
                                    </div>
                                </div>
                                <div>
                                    {data.patientData.length > 0 ? (
                                        <>
                                            <div className='flex sticky top-[48px] bg-white z-10 justify-end'>
                                                <div className='flex  pt-5 pb-2.5 left-0 z-30 justify-end'>
                                                    <button type='button' id='collapse_all' className='text-[16px] text-[#008586] leading-normal font-normal'>
                                                        <span className='cursor-pointer' onClick={() => setCollapsedNotes(new Array(data.patientData.length).fill(true))}>Collapse All</span>
                                                    </button>
                                                    <button type='button' id='expand_all' className='pl-[16px] text-[16px] text-[#008586]  leading-normal font-normal'>
                                                        <span className='cursor-pointer' onClick={() => setCollapsedNotes(new Array(data.patientData.length).fill(false))}>Expand All</span>
                                                    </button>
                                                </div>
                                            </div>
                                            <div>
                                                {data?.patientData.map((note, index) => (
                                                    <div key={index}>
                                                        <div className='bg-[#E5F3F3] w-full items-center py-2 rounded-[4px] mt-[7px] flex px-4 cursor-pointer' onClick={() => handleCollapseToggle(index)}>
                                                            <p className='text-[18px] text-[#000] font-normal leading-normal'>
                                                                {note?.first_name || ''} <span className='pl-1'>{note?.last_name || ''}</span> <span className='pl-1'>({user_type_labels[note.user_type] || note.user_type})</span><span className='pl-2'>{note.user_id}</span>
                                                            </p>
                                                            <p className='text-[14px] pl-[24px] text-[#52555D] font-normal leading-normal'>{convertEpochToDateFormat(note.updated_at, dateformat)} {(note.end_time)}</p>
                                                            <img className={`ml-auto cursor-pointer rotate ${!collapsedNotes[index] ? "rotate-180" : 'rotate-0'}`} src="/images/collapse.svg" alt="collapse" />
                                                        </div>
                                                        {!collapsedNotes[index] && (
                                                            <textarea
                                                                id={'added_notes'}
                                                                readOnly
                                                                value={note.description}
                                                                className='text-[16px] py-2 text-[#000000] font-normal w-full outline-0 resize-none auto-height-textarea'
                                                            />
                                                        )}
                                                    </div>
                                                ))}
                                            </div>
                                        </>)
                                        :
                                        <>
                                            {data?.patientData?.length === 0 && (searchParams.get("start_date") !== null || searchParams.get("end_date") !== null || searchParams.get("monitor_list") !== null) ?
                                                <SearchEmptyScreen welnesscontact={true} text={"That filter combination has no result. Please try different criteria"} />
                                                :
                                                data?.patientData.length === 0 ?
                                                    <Emptyscreen
                                                        ViewNotes={true}
                                                        PatientNotes={true}
                                                        title={"Manage Patients"}
                                                        FirstPTag={"No Wellness notes to view yet."}
                                                    />
                                                    : ((status === "rejected" || (data?.total_count !== 0 && data?.data?.length === 0)) && <SearchEmptyScreen text={"No data found"} />)
                                            }
                                        </>
                                    }
                                </div>
                            </div>
                        </motion.div>
                    </div>
                </>}
                {addNoteModal && (
                    <AnimatedModel
                        Children={
                            <ConfirmationPrompt
                                handleOnCLickActivate={handleAppendNotes}
                                handleClose={() => { setAddWellnessModal(false) }}
                                tittle={'Save'}
                                message={'Are you sure you want to save the note?'}
                                buttonName={true && !saveThreedotLoader ? "Yes" : <span>{<Loader />}</span>}
                                CancelButton={'No'}
                                disabled={saveThreedotLoader}
                            />
                        }
                    />
                )}
                {(helpGuideModel && helpguidestatus==="fulfilled") &&
                <HelpGuideModal
                    setHelpGuideModel={setHelpGuideModel}
                    pdfUrl={helpguidedata} // Pass the PDF URL to the modal
                />
                }
            </div>
        </>
    )
}

export default ContactHistory